import { useState } from 'react'
import { useNavigate } from 'react-router'
import Alert from '@cloudscape-design/components/alert'
import Box from '@cloudscape-design/components/box'
import Button from '@cloudscape-design/components/button'
import Container from '@cloudscape-design/components/container'
import FormField from '@cloudscape-design/components/form-field'
import Input from '@cloudscape-design/components/input'
import Modal from '@cloudscape-design/components/modal'
import SpaceBetween from '@cloudscape-design/components/space-between'
import Page from '@/components/common/Page'
import { useDeleteAccount } from '@/hooks/useAccount'
import { useAuthStore } from '@/state/authStore'

export default function DangerZonePage() {
  const navigate = useNavigate()
  const { deleteAccount, loading: deletingAccount } = useDeleteAccount()
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [confirmText, setConfirmText] = useState('')

  const handleClose = () => {
    setShowDeleteModal(false)
    setConfirmText('')
  }

  const handleDelete = () => {
    deleteAccount().then(() => {
      useAuthStore.getState().clearAuth()
      navigate('/auth')
    })
    setConfirmText('')
  }

  return (
    <Page
      title="Danger Zone"
      helpContent={{
        header: 'Danger Zone',
        body: (
          <div>
            <p>Destructive account operations. Be careful - these actions cannot be undone.</p>
            <h4>Available Actions:</h4>
            <ul style={{ marginLeft: 20 }}>
              <li><strong>Delete Account</strong> - Permanently delete your entire account and all associated data</li>
            </ul>
            <h4>Warning:</h4>
            <p>Deleting your account is permanent. All your agents, configurations, content, and history will be permanently removed. This action requires confirmation.</p>
          </div>
        ),
      }}
    >
      <Container>
        <SpaceBetween size="m">
          <SpaceBetween size="xs">
            <Box variant="h3">Delete Account</Box>
            <Box variant="p" color="text-status-error">
              Permanently deletes your account and all associated data — clients, campaigns, knowledge bases, integrations, and billing history. This action cannot be undone.
            </Box>
          </SpaceBetween>
          <Button variant="normal" onClick={() => setShowDeleteModal(true)}>Delete Account</Button>
        </SpaceBetween>

        <Modal
          visible={showDeleteModal}
          header="Delete account permanently?"
          onDismiss={handleClose}
          footer={
            <SpaceBetween direction="horizontal" size="xs">
              <Button variant="link" onClick={handleClose}>Cancel</Button>
              <Button variant="normal" loading={deletingAccount} disabled={confirmText !== 'confirm'} onClick={handleDelete}>
                Delete Account
              </Button>
            </SpaceBetween>
          }
        >
          <SpaceBetween size="m">
            <Alert type="error">
              This will permanently delete your account and all associated data. This action cannot be undone.
            </Alert>
            <FormField
              label='Type "confirm" to proceed'
              description="All clients, campaigns, knowledge bases, platform connections, and billing history will be deleted."
            >
              <Input
                value={confirmText}
                onChange={(e) => setConfirmText(e.detail.value)}
                placeholder="confirm"
              />
            </FormField>
          </SpaceBetween>
        </Modal>
      </Container>
    </Page>
  )
}
